import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import VideocamOutlinedIcon from 'components/material-symbol/icons/Videocam'

const useStyles = makeStyles(theme => ({
  root: {
    width: 72,
    height: 44,
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: '#EBF0F2',
    color: theme.palette.text.secondary,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

const VideoThumbnail = ({ src, alt }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      {src ? (
        <img className={classes.image} src={src} alt={alt} />
      ) : (
        <VideocamOutlinedIcon fontSize="small" aria-label={alt} />
      )}
    </Box>
  )
}

VideoThumbnail.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
}

export default VideoThumbnail
